<div class="clipping-window">
  <div
    [style.width.px]="parentWidth"
    [style.height.px]="fitToGrandParent ? parentHeight : 'auto'"
    class="clipped-content"
  >
    <ng-content></ng-content>
  </div>
</div>

